export { ContextMenuModule } from './ngx-contextmenu';
export * from './contextMenu.component';
export * from './contextMenu.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/ngx-contextmenu/lib/index.js
// module id = ../../../../ngx-contextmenu/lib/index.js
// module chunks = vendor